import src from "IMAGE";
export default { src, width: 267, height: 48, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRkYAAABXRUJQVlA4TDkAAAAvBwAAEM1VICICEeGBAAEAAAAAnD8kAAAAAAAIAAAAAAAgAAAAAAAAAAAAAAAAAAQAAAABYXqNwAMA"};
